// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + "90120720883ae66b" + ".css"
}